var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.styles.root)},[_c('svg',{style:({
            width: '100%',
            height: '100%',
        })},[_c('path',{style:(_vm.styles.path),attrs:{"d":_vm.path}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }